<template>
  <div class="view">
    <h1>Not Found</h1>
    <p>ページが見つかりませんでした。</p>
  </div>
</template>

<script>
import { setMeta } from "../lib/meta";

export default {
  mounted() {
    setMeta({
      subtitle: "NotFound",
      description: "ページが見つかりませんでした。",
      path: this.$route.path,
      image: undefined
    });
  }
};
</script>

<style lang="scss" scoped>
h1 {
  padding: 1em 0;
  text-align: center;
}
</style>
